<template>
  <div class="payment-item" :class="modifierClass">
    <img :src="require('@/assets/ic_ruble.svg')" class="icon" alt="">
    <div class="payment-item__info">
      <div class="title">{{ titleText }}</div>
      <div class="date">{{convertTime(item.timestamp)}}</div>
    </div>
    <div class="price-container">
      <div class="price">{{ amountWithCurrency }}</div>
      <button
        v-if="canRepeat"
        type="button"
        class="payment-item__repeat"
        @click.stop="handleRepeat"
      >
        Повторить платеж
      </button>
    </div>

  </div>

</template>

<script>
export default {
  name: "item-payment",
  props: {
    item: Object
  },
  computed: {
    paymentType() {
      const raw = typeof this.item?.type === 'string' ? this.item.type.toLowerCase() : '';
      return raw === 'debit' ? 'debit' : 'payment';
    },
    modifierClass() {
      return `payment-item--${this.paymentType}`;
    },
    titleText() {
      return this.paymentType === 'debit' ? 'Списание за услугу' : 'Пополнение баланса';
    },
    normalizedAmount() {
      const amount = this.item?.amount;
      if (amount === null || amount === undefined) {
        return null;
      }
      const normalized = String(amount).replace(/[^0-9,.-]/g, '').replace(',', '.');
      const parsed = parseFloat(normalized);
      return Number.isNaN(parsed) ? null : parsed;
    },
    canRepeat() {
      return this.paymentType === 'payment' && this.normalizedAmount !== null && this.normalizedAmount >= 1;
    },
    amountWithCurrency() {
      const amount = this.item?.amount;
      if (amount === null || amount === undefined) {
        return '0₽';
      }
      if (typeof amount === 'number') {
        return `${amount.toLocaleString('ru-RU')}₽`;
      }
      if (typeof amount === 'string') {
        return amount.includes('₽') ? amount : `${amount}₽`;
      }
      return `${amount}₽`;
    }
  },
  methods: {
    handleRepeat() {
      this.$emit('repeat', { item: this.item, amount: this.normalizedAmount });
    },
    convertTime(time) {
      if (time === -1) {
        return 'Отправка...';
      }
      const date = new Date(time * 1000);
      // var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };


      // const hours = date.getHours();
      // const minutes = "0" + date.getMinutes();
      // return date.getDate() + '.'+ date.getMonth()+'.'+ date.getFullYear()+' '+ hours + ':' + minutes.substr(-2);
      return date.toLocaleDateString()+', '+ date.toLocaleTimeString().slice(0,-3)
    }
  }
}
</script>

<style scoped>

.payment-item {
  text-align: start;
  background: white;
  border-radius: 24px;
  height: max-content;
  box-shadow: 0 0 16px rgba(41, 48, 67, 0.15);
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: max-content 1fr 200px;
  align-items: stretch;
}

.payment-item .price-container {
  text-align: center;
  border-radius: 0 16px 16px 0;
  padding: 12px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.payment-item .price-container .price{
  font-family: "Mont", serif;
  margin: 0;
  font-weight: bold;
  color: white;
  font-size: 1.8rem;
  line-height: 1.8rem;

}

.payment-item__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 0;
}

.payment-item .title {
  font-family: "Mont", serif;
  margin-top: 0;
  margin-left: 16px;
  font-weight: bold;
  color: #2D666E;
  font-size: 1.4rem;
  line-height: 1.4rem;
}

.payment-item .date{
  font-family: "Mont", serif;
  margin-top: 6px;
  margin-left: 16px;
  font-weight: bold;
  color: #9b9b9b;
  font-size: 1rem;
  line-height: 1rem;
}

.payment-item .icon {
  display: inline-block;
  align-self: center;
  margin-left: 16px;
  height: 56px;
  width: 56px;
}

.payment-item--payment .price-container {
  background: #58B1DA;
}

.payment-item--debit .price-container {
  background: #DF0E0E;
}

.payment-item__repeat {
  border: none;
  border-radius: 12px;
  padding: 6px 10px;
  font-family: "Mont", serif;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  color: #2D666E;
  background: rgba(255, 255, 255, 0.9);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.payment-item__repeat:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
}

.payment-item__repeat:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}


</style>
